import React, { useState, useContext, useEffect } from "react";
import AuthContext from "../../context/auth/authContext";
import TradathonContext from "../../context/tradathon/TradathonContext";

import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import LiveCard from "../../components/LiveCard";
import CompletedCard from "../../components/CompletedCard";
import PreWinnings from "../../components/PreWinnings";
const TradathonRoom = ({ history, match, location }) => {
  const [create, setCreate] = useState(true);
  const [openShare, setOpenShare] = useState(false);
  const [roomId, setRoomId] = useState(match.params.id);
  const [terms, setTerms] = useState(false);
  const [openWinnings, setOpenWinnings] = useState(false);
  const {
    createRoom,
    createRoomData,
    joinRoom,
    tradathonRoomLoading,
    getRoom,
    roomDetails,
    tradathonLoading,
  } = useContext(TradathonContext);
  const { userData } = useContext(AuthContext);
  let date_1 = new Date();
  date_1.setMinutes(0);
  date_1.setSeconds(0);
  const date_2 = new Date(new Date().setDate(new Date().getDate() + 1));
  date_2.setMinutes(0);
  date_2.setSeconds(0);
  const [roomCreate, setRoomCreate] = useState({
    rname: "",
    rtype: "custom",
    noOfWinners: "",
    startTime: date_1,
    endTime: date_2,
    noOfPlayers: "",
    entryFees: "",
    pid: userData.profile_data._id,
  });

  useEffect(() => {
    if (location.pathname.split("/").includes("join")) {
      setCreate(false);
    }
    // if (roomId) getRoom(roomId);
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (createRoomData && createRoomData.data) {
      if (location.pathname.split("/").includes("join")) {
        history.push(
          `/tradathon/addcoins?rmid=${createRoomData.data.roomMember._id}&rid=${createRoomData.data.roomMember.rid}`
        );
      } else {
        history.push(
          `/tradathon/room/share?rcode=${createRoomData.data.roomData.rcode}`
        );
      }
    }
    // if(!create&&createRoomData && createRoomData.data) {
    //   history.push(
    //     `/tradathon/addcoins?rmid=${createRoomData.data.roomMember._id}&rid=${createRoomData.data.roomMember.rid}`
    //   );
    //   console.log(createRoomData)
    //  }
    //eslint-disable-next-line
  }, [createRoomData]);
  const handleSearch = () => {
    if (roomId) {
      getRoom(roomId);
    } else {
      toast.error("Room code is empty", { autoClose: 6000 });
    }
  };
  const handleRoomClick = () => {
    setOpenShare(!openShare);
  };
  const handleClick = () => {
    if (
      roomCreate.rname === null ||
      roomCreate.rname === "" ||
      roomCreate.rtype === null ||
      roomCreate.rtype === "" ||
      roomCreate.noOfWinners === "" ||
      roomCreate.noOfWinners === null ||
      roomCreate.noOfPlayers === "" ||
      roomCreate.noOfPlayers === null ||
      roomCreate.entryFees === "" ||
      roomCreate.entryFees === null
    ) {
      toast.error("Fields cannot be empty", { autoClose: 6000 });
    } else if (roomCreate.rname.length > 16) {
      toast.error("Count of characters in room name cannot exceed 16", {
        autoClose: 6000,
      });
    } else if (roomCreate.noOfPlayers > 20000 || roomCreate.noOfPlayers < 2) {
      toast.error(
        "Minimum Number of players cannot be lesser than 2 and Maximum Number of Players cannot exceed 20,000",
        {
          autoClose: 6000,
        }
      );
    } else if (
      roomCreate.noOfWinners > roomCreate.noOfPlayers ||
      roomCreate.noOfWinners > roomCreate.noOfPlayers / 2
    ) {
      toast.error(
        "Winners cannot exceed more than half of Maximum Number of Players",
        {
          autoClose: 6000,
        }
      );
    } else if (roomCreate.entryFees < 10 || roomCreate.entryFees > 100000) {
      toast.error(
        "Entry Fees of a contest cannot be lesser than ₹10 and greater than ₹1,00,000",
        { autoClose: 6000 }
      );
    } else if (roomCreate.startTime.getTime() < new Date().getTime()) {
      toast.error("Please select correct start time", { autoClose: 6000 });
    } else if (roomCreate.startTime.getTime() > roomCreate.endTime.getTime()) {
      toast.error("Please select correct start time", { autoClose: 6000 });
    } else if (!terms) {
      toast.error("Please accept terms and conditions and then proceed", {
        autoClose: 6000,
      });
    } else {
      createRoom(roomCreate);
    }
  };
  const handleJoin = () => {
    if (!roomId) {
      toast.error("Please enter Room Code and then proceed to join", {
        autoClose: 6000,
      });
    } else {
      joinRoom({
        rcode: roomId,
        pid: userData.profile_data._id,
      });
    }
  };
  const handleTerms = (e) => {
    setTerms(e.target.checked);
  };
  const handleWinningsClick = () => {
    
   if(roomCreate.entryFees===""){
    toast.error("Entry Fees is empty! you cannot get Winnings", {
      autoClose: 6000,
    });
    }
    else if(roomCreate.noOfPlayers===""){
      toast.error("No of Players is empty! you cannot get Winnings", {
        autoClose: 6000,
      });
    }
    else if(roomCreate.noOfWinners===""){
      toast.error("No of winners is empty! you cannot get Winnings", {
        autoClose: 6000,
      });
    }
    else{

    setOpenWinnings(true);
    }
  };
  const handleCloseWinningsClick = () => {
    setOpenWinnings(false);
  };
  return (
    <div className="TradathonRoom">
      {openWinnings && (
        <PreWinnings
          close={handleCloseWinningsClick}
          formData={{
            noOfMembers: roomCreate.noOfPlayers,
            entryFee: roomCreate.entryFees,
            noOfWinner: roomCreate.noOfWinners,
            rtype: "custom",
          }}
        />
      )}
      <div className="TradathonRoomContainer">
        <h1>Create Own Room</h1>
        <div
          className="TradathonRoom__formContainer"
          style={{ width: !create && "100%" }}
        >
          <>
            <center>
              <div
                className="TradathonRoom__formContainer__toggleSwitch"
                style={{ width: "201px" }}
              >
                <div
                  className="TradathonRoom__formContainer_toggleSwitch__items"
                  style={{
                    color: create ? "#fff" : "#000",
                    background: create ? "#8d0792" : "#eff2f5",
                  }}
                  onClick={() => setCreate(!create)}
                >
                  <h4>CREATE</h4>
                </div>
                <div
                  className="TradathonRoom__formContainer_toggleSwitch__items"
                  style={{
                    color: create ? "#000" : "#fff",
                    background: create ? "#eff2f5" : "#8d0792",
                  }}
                  onClick={() => setCreate(!create)}
                >
                  <h4>JOIN</h4>
                </div>
              </div>
            </center>
            {create ? (
              <>
                <table>
                  <tbody>
                    <tr>
                      <td>Room Name :</td>
                      <td>
                        <input
                          type="text"
                          value={roomCreate.rname}
                          onChange={(e) =>
                            setRoomCreate({
                              ...roomCreate,
                              rname: e.target.value,
                            })
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Entry Fees :</td>
                      <td>
                        <input
                          type="text"
                          value={roomCreate.entryFees}
                          onChange={(e) =>
                            setRoomCreate({
                              ...roomCreate,
                              entryFees: Number(e.target.value),
                            })
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={{ whiteSpace: "nowrap" }}>
                        Max No of Player :
                      </td>
                      <td>
                        <input
                          type="text"
                          value={roomCreate.noOfPlayers}
                          onChange={(e) =>
                            setRoomCreate({
                              ...roomCreate,
                              noOfPlayers: Number(e.target.value),
                            })
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>No.of Winners :</td>
                      <td>
                        <input
                          type="text"
                          value={roomCreate.noOfWinners}
                          style={{ width: "50%" }}
                          onChange={(e) =>
                            setRoomCreate({
                              ...roomCreate,
                              noOfWinners:Number(e.target.value),
                            })
                          }
                        />
                        <p style={{display: 'inline-block',marginLeft:"10px",cursor:"pointer"}}
                          onClick={() => {
                            handleWinningsClick();
                          }}
                        >
                          Get Winnings
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div className="TradathonRoom__dateContainer">
                  <div>
                    Start Time :
                    <Datetime
                      value={roomCreate.startTime}
                      timeFormat="hh A"
                      onChange={(Moment) =>
                        setRoomCreate({ ...roomCreate, startTime: Moment._d })
                      }
                      // isValidDate={(currentDate,selectedDate)=>moment(selectedDate).isBefore(currentDate)}
                    />
                  </div>
                  <div>
                    End Time :
                    <Datetime
                      value={roomCreate.endTime}
                      timeFormat="hh A"
                      onChange={(Moment) =>
                        setRoomCreate({ ...roomCreate, endTime: Moment._d })
                      }
                    />
                  </div>
                </div>
                <div className="TradathonRoom__terms">
                  <input type="checkbox" onChange={handleTerms} />I Accept
                  <Link to="/terms-and-conditions">
                    &nbsp; Terms & Conditions
                  </Link>
                </div>
              </>
            ) : (
              <div className="TradathonRoom__join__container">
                <div className="TradathonRoom__join">
                  <p style={{ whiteSpace: "nowrap" }}>Enter a code:</p>
                  <input
                    type="text"
                    value={roomId}
                    onChange={(e) => setRoomId(e.target.value)}
                  />

                  <button
                    className="TradathonRoom__join__button"
                    style={{
                      background: "rgba(69, 170, 67, 1)",
                      borderRadius: "5px",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                    onClick={() => handleSearch(roomId)}
                    disabled={tradathonRoomLoading}
                  >
                    SEARCH
                    {tradathonLoading && (
                      <div
                        className="loader1"
                        style={{
                          height: "20px",
                          width: "20px",
                          display: "inline-block",
                          border: "3px solid #f3f3f3",
                          borderTop: "3px solid rgba(69, 170, 67, 1)",
                          marginLeft: "5px",
                        }}
                      ></div>
                    )}
                  </button>
                </div>
                <div className="TradathonRoom__join__hr"></div>
                {/* <table style={{ textAlign: "right" }}>
                  <tr>
                    <td>
                      <img
                        src={userData?.profile_data.avatar}
                        alt="profile"
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "50%",
                        }}
                      />
                    </td>
                    <td>{userData?.profile_data.name.split(" ")[0]}</td>
                    <td style={{ whiteSpace: "nowrap" }}>
                      Net P&L : +200
                      <span style={{ color: "red" }}>(-1.6%)</span>
                    </td>
                    <td>
                    <button
                    className="TradathonRoom__join__button"
                    style={{
                      background: "rgba(232, 189, 110, 1)",
                      borderRadius: "5px",
                    }}
                  >
                    SEARCH
                  </button>
                    </td>
                  </tr>
                </table> */}
              </div>
            )}
            <center>
              {!location.pathname.split("/").includes("join") && create && (
                <button
                  className="TradathonRoom__button"
                  onClick={() => {
                    handleClick();
                    handleRoomClick();
                  }}
                  disabled={tradathonRoomLoading}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  CREATE
                  {tradathonRoomLoading && (
                    <div
                      className="loader1"
                      style={{
                        height: "20px",
                        width: "20px",
                        display: "inline-block",
                        border: "3px solid #f3f3f3",
                        borderTop: "3px solid #e8bd6e",
                        marginLeft: "5px",
                      }}
                    ></div>
                  )}
                </button>
              )}

              <div style={{ textAlign: "left" }}>
                {roomDetails ? (
                  roomDetails.rstatus === 1 || roomDetails.rstatus === 0 ? (
                    <LiveCard
                      key={roomDetails._id}
                      noOfPlayers={roomDetails.noOfPlayers}
                      startTime={roomDetails.startTime}
                      endTime={roomDetails.endTime}
                      entryFees={roomDetails.entryFees}
                      // prize={roomDetails.prize}
                      rtype={roomDetails.rtype}
                      joinedMembers={roomDetails.membersJoined}
                      rname={roomDetails.rname}
                      isFlexible={roomDetails.isFlexible}
                      rstatus={roomDetails.rstatus}
                      rcode={roomDetails.rcode}
                      // isPaid={roomDetails.isPaid}
                      rid={roomDetails._id}
                    />
                  ) : (
                    <CompletedCard
                      key={roomDetails._id}
                      noOfPlayers={roomDetails.noOfPlayers}
                      startTime={roomDetails.startTime}
                      endTime={roomDetails.endTime}
                      entryFees={roomDetails.entryFees}
                      // prize={roomDetails.prize}
                      rtype={roomDetails.rtype}
                      joinedMembers={roomDetails.membersJoined}
                      rname={roomDetails.rname}
                      isFlexible={roomDetails.isFlexible}
                      rstatus={roomDetails.rstatus}
                      rcode={roomDetails.rcode}
                      // isPaid={roomDetails.isPaid}
                      rid={roomDetails._id}
                      
                    />
                  )
                ) : (
                  <></>
                )}
              </div>
              {!create && (
                <button
                  className="TradathonRoom__join__button"
                  style={{
                    background: "rgba(232, 189, 110, 1)",
                    borderRadius: "5px",
                    marginTop: "10px",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                  onClick={handleJoin}
                >
                  JOIN
                  {tradathonRoomLoading && (
                    <div
                      className="loader1"
                      style={{
                        height: "20px",
                        width: "20px",
                        display: "inline-block",
                        border: "3px solid #f3f3f3",
                        borderTop: "3px solid rgba(232, 189, 110, 1)",
                        marginLeft: "5px",
                      }}
                    ></div>
                  )}
                </button>
              )}
            </center>
          </>
        </div>
      </div>
    </div>
  );
};

export default TradathonRoom;
